module.exports = __webpack_public_path__ + "static/media/football_icon.0fb53738.png";